import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import EbillingEnrollmentDetail from './EbillingEnrollmentDetail';

const EbillingEnrollmentDetailModal = ({ selectedAccount, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant='primary' onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>eBilling Enrollment Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EbillingEnrollmentDetail selectedAccount={selectedAccount} />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

EbillingEnrollmentDetailModal.propTypes = {
  selectedAccount: PropTypes.instanceOf(Object).isRequired,
};

export default EbillingEnrollmentDetailModal;
